"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuestionType = exports.Question = void 0;
var uuid_1 = require("uuid");
var node_1 = require("./node");
var Question = /** @class */ (function () {
    function Question(arg) {
        // this.validateConstructorArg(arg);
        this.id = arg.id || uuid_1.v1();
        this.answers = arg.answers;
        if (arg.scorepoints) {
            this.scorepoints = arg.scorepoints;
        }
        if (arg.nodes) {
            this.nodes = arg.nodes;
        }
    }
    return Question;
}());
exports.Question = Question;
exports.isQuestionType = function (type) {
    switch (type) {
        case node_1.NODE_TYPES.QUESTION_SINGLE:
        case node_1.NODE_TYPES.QUESTION_MULTIPLE:
        case node_1.NODE_TYPES.QUESTION_DESCRIPTION:
        case node_1.NODE_TYPES.QUESTION_RATING:
        case node_1.NODE_TYPES.QUESTION_SLIDER:
        case node_1.NODE_TYPES.QUESTION_OPEN_ENDED:
        case node_1.NODE_TYPES.QUESTION_NUMERIC_OPEN_ENDED:
        case node_1.NODE_TYPES.QUESTION_RANKING:
        case node_1.NODE_TYPES.QUESTION_MATRIX_SINGLE:
        case node_1.NODE_TYPES.QUESTION_MATRIX_MULTIPLE:
        case node_1.NODE_TYPES.QUESTION_NPS: {
            return true;
        }
        default:
            return false;
    }
};
